var path = '/static/assets/khapps/fms_app/admin/slow-queries-chart.component.html';
var html = "<md-progress-linear md-mode=\"indeterminate\" ng-show=\"$ctrl.loading\"></md-progress-linear>\n<highchart ng-if=\"$ctrl.config\" id=\"slow-queries\" config=\"$ctrl.config\"></highchart>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;